import { useEffect, useCallback } from "react";
import { useRefsContext } from "@/contexts/ref";
import { InteractionEnum } from "@/types";
import { useCustomerAction } from "@/hooks";
export const useSectionObserver = () => {
    const context = useRefsContext();
    const { customerActionExposeInteraction } = useCustomerAction();
    const isElementVisible = useCallback((element) => {
        const rect = element ? element.getBoundingClientRect() : null;
        return rect && rect.top < window.innerHeight && rect.bottom >= 0;
    }, []);
    const elementSection = (sectionRef) => sectionRef &&
        "current" in sectionRef &&
        (sectionRef === null || sectionRef === void 0 ? void 0 : sectionRef.current) instanceof HTMLElement
        ? sectionRef === null || sectionRef === void 0 ? void 0 : sectionRef.current
        : null;
    useEffect(() => {
        const handleScroll = () => {
            Object.entries(context).forEach(([sectionName, sectionRef]) => {
                if (isElementVisible(elementSection(sectionRef))) {
                    customerActionExposeInteraction([
                        { interaction: InteractionEnum.SCROLLING },
                        { value: sectionName.replace("Ref", "") },
                    ], `CustomerActionScrollSection-${sectionName.replace("Ref", "")}`);
                }
            });
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [context, isElementVisible, customerActionExposeInteraction]);
};
